/**
 * 環境標示（build 時寫入）
 *
 * 由各部署分支的 CI 以 build-arg 傳入（見部署分支 .gitlab-ci.yml 的 build-web / build-lineat）：
 *   VITE_ENV_LABEL  標示文字，例如「客戶測試環境」；空值 = 正式，不顯示
 *   VITE_BUILD_REF  建置分支（CI_COMMIT_REF_NAME）
 *   VITE_BUILD_SHA  建置 commit（CI_COMMIT_SHORT_SHA）
 *
 * 刻意在 build 時決定、而非依網址或部署環境：標示代表「這份程式是哪條分支 build 的」，
 * 映像若部署錯環境（例如測試映像跑到正式），畫面會出現不該有的標示，一眼可見。
 *
 * 顯示方式：右上角斜帶（pointer-events: none，不擋點擊、不改版面）＋ 分頁標題前綴。
 * 正式（無標示）不顯示畫面元素，只在 console 與 <meta name="build-info"> 留建置資訊。
 *
 * ※ 與 towconnect-web/src/utils/envBanner.ts 為同一份實作，修改時兩邊一起改。
 */
export function installEnvBanner(): void {
  const label = (import.meta.env.VITE_ENV_LABEL || '').trim()
  const ref = import.meta.env.VITE_BUILD_REF || 'local'
  const sha = import.meta.env.VITE_BUILD_SHA || 'dev'
  const info = `${label || '正式'} ・ ${ref} ・ ${sha}`

  const meta = document.createElement('meta')
  meta.name = 'build-info'
  meta.content = info
  document.head.appendChild(meta)
  console.info(`[build] ${info}`)

  if (!label) return

  if (!document.title.startsWith(`[${label}]`)) {
    document.title = `[${label}] ${document.title}`
  }

  const ribbon = document.createElement('div')
  ribbon.textContent = label
  ribbon.title = info
  ribbon.setAttribute('aria-hidden', 'true')
  ribbon.style.cssText = [
    'position:fixed',
    'top:38px',
    'right:-58px',
    'width:230px',
    'transform:rotate(45deg)',
    'background:rgba(234,88,12,0.45)',
    'color:rgba(255,255,255,0.9)',
    'font:700 12px/24px system-ui,-apple-system,"Noto Sans TC",sans-serif',
    'text-align:center',
    'letter-spacing:1px',
    'box-shadow:none',
    'z-index:2147483647',
    'pointer-events:none',
    'user-select:none',
  ].join(';')
  document.body.appendChild(ribbon)
}
